import { render, staticRenderFns } from "./CoozzyMatchingPopover.vue?vue&type=template&id=04b767cb&scoped=true"
import script from "./CoozzyMatchingPopover.vue?vue&type=script&lang=js"
export * from "./CoozzyMatchingPopover.vue?vue&type=script&lang=js"
import style0 from "./CoozzyMatchingPopover.vue?vue&type=style&index=0&id=04b767cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b767cb",
  null
  
)

export default component.exports